export default "/fonts/vendor/katex/dist/KaTeX_Main-BoldItalic.woff2?20f389c4120be058d80a3cd6a2f5a9b9";